import axios from 'utils/axios';
import * as types from './ActionTypes';
import { API_URL } from 'configs';


import { showSuccessModal } from 'actions';

const loader = label => ({ type: types.SHOW_LOADER, common_loader_label: label });
const hideLoader = () => ({ type: types.HIDE_LOADER });

const snackbar = (msg, type = 'general_error') => ({
  type: types.SHOW_SNACKBAR,
  snackbar_notification: msg,
  snackbar_notification_type: type,
});

const handleError = (error, dispatch, validationType) => {
  const res = error?.response; 
  if (res?.status === 422){ 
    dispatch({ type: validationType, validation_error: res.data.errors });
  } 
  else dispatch(snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`));
};

export const timeSheetCategoryRedirectToList = () => ({ type: types.CATEGORIES_REDIRECT });

const fetchSuccess = (type, listKey) => data => ({
  type,
  [listKey]: data
});

const getSuccess = (type) => (data, action) => ({
  type,
  record: data,
  actionType: action
});

export const hideCategoryValidationError = (feild_key) => ({
  type: types.HIDE_CATEGORIES_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
})

export const fetchCategories = (params = {}) => dispatch => {
  dispatch({ type: types.CATEGORIES_REQUEST });
  dispatch(loader());

  axios.post(`${API_URL}timesheet/categories/list`, params, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch(fetchSuccess(types.CATEGORIES_SUCCESS, 'categoriesList')(res.data));
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.CATEGORIES_VALIDATION_ERROR);
    });
};

export const getCategoryById = (id, actionType, object_viewed_id) => dispatch => {
  dispatch({ type: types.CATEGORIES_REQUEST });
  dispatch(loader());

  axios.get(`${API_URL}timesheet/categories/${id}`, {
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch(getSuccess(types.CATEGORIES_GET_SUCCESS)(res.data, actionType));
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.CATEGORIES_VALIDATION_ERROR);
    });
};

export const createOrUpdateCategory = (data, method = 'POST', object_viewed_id) => dispatch => {
  dispatch({ type: types.CATEGORIES_REQUEST });
  dispatch(loader());

  const url = method === 'POST'
    ? `${API_URL}timesheet/categories`
    : `${API_URL}timesheet/categories/${data.id}`;

  axios({
    url,
    method,
    data,
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(() => {
      dispatch(hideLoader());
      dispatch(showSuccessModal(`Category ${method === 'POST' ? 'created' : 'updated'} successfully`));
      dispatch(timeSheetCategoryRedirectToList());
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.CATEGORIES_VALIDATION_ERROR);
    });
};

export const deleteCategory = (id, object_viewed_id) => dispatch => {
  dispatch({ type: types.CATEGORIES_REQUEST });
  dispatch(loader());

  axios.delete(`${API_URL}timesheet/categories/${id}`, {
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(() => {
      dispatch(hideLoader());
      dispatch(snackbar('Category deleted', 'success'));
      dispatch(fetchCategories({ object_viewed_id })); // Refetch list after delete
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.CATEGORIES_VALIDATION_ERROR);
    });
};

export const fetchTimesheetCategoriesDropdown = (object_viewed_id) => dispatch => {
  dispatch({ type: types.CATEGORIES_REQUEST });
  axios.get(`${API_URL}timesheet/categories/dropdown`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem("token")}`
    },
    params: { object_viewed_id }
  })
    .then(res => {
      dispatch(fetchSuccess(types.CATEGORIES_DROPDOWN_SUCCESS, 'categoriesDropdownList')(res.data));
    })
    .catch(err => {
      handleError(err, dispatch, types.CATEGORIES_VALIDATION_ERROR);
    });
};

